import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api, setToken, setAdminUsername, getToken } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Card } from '../../components/ui/card';
import { Loader2, Lock } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (getToken()) {
    // already logged in — take user to dashboard
    navigate('/admin', { replace: true });
  }

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post('/auth/login', { username, password });
      setToken(data.access_token);
      setAdminUsername(data.username);
      toast.success('Welcome back!');
      navigate('/admin', { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || 'Invalid login';
      toast.error(msg);
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a1628] text-white relative overflow-hidden">
      <div className="absolute inset-0 hero-radial pointer-events-none" />
      <div className="relative max-w-md mx-auto px-4 py-20">
        <Link to="/" className="inline-flex items-center gap-3 mb-8">
          <img src="/brand/logo.jpeg" alt="" className="h-10 w-10 rounded-full object-cover ring-1 ring-[#c8e600]/40" />
          <div className="font-display font-semibold">Arab Diver Tours</div>
        </Link>
        <Card className="rounded-3xl border-white/10 bg-white/[0.04] p-8 backdrop-blur">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-10 w-10 rounded-xl bg-[#c8e600]/15 text-[#c8e600] inline-flex items-center justify-center"><Lock className="h-5 w-5" /></div>
            <div>
              <div className="font-display text-xl font-semibold">Admin sign-in</div>
              <div className="text-xs text-white/55">Manage trips, shop, team and course content</div>
            </div>
          </div>
          <form data-testid="admin-login-form" onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-white/80">Username</Label>
              <Input data-testid="admin-login-username-input" autoComplete="username" autoFocus value={username} onChange={(e) => setUsername(e.target.value)} className="mt-1.5 bg-white/5 border-white/15 text-white" />
            </div>
            <div>
              <Label className="text-white/80">Password</Label>
              <Input data-testid="admin-login-password-input" autoComplete="current-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-white/5 border-white/15 text-white" />
            </div>
            <Button data-testid="admin-login-submit-button" type="submit" disabled={submitting || !username || !password} className="w-full bg-[#c8e600] text-[#0a1628] hover:bg-[#b6d100] font-semibold rounded-xl h-11">
              {submitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in…</> : 'Sign in'}
            </Button>
          </form>
          <p className="mt-6 text-xs text-white/45">Forgot your credentials? Contact the site owner.</p>
        </Card>
      </div>
    </div>
  );
}
